import React, {} from "react"
import axios from 'axios';
import { logApiRequest } from '../mixpanelInterface';


export default function get_and_post_data_skeleton(
        url,
        method='get',
        inf_scroll=false,
        data={},
        success_func_name=null,
        url_return=false,
        home_page=false,
        error_func_name=null,
        add_influencer_page_alterations=false,
    ) {
    //  originally try and get the data with the access token
    const startTime = performance.now();
    const actingAs = localStorage.getItem('acting_as_creator');
    const headers = {
        'Content-type': 'application/json',
    };
    if (actingAs) {
        headers['X-Acting-As'] = actingAs;
    }
    axios(
        {
        method: method,
        url: url,
        data: data,
        headers: headers,
        withCredentials: true,
        maxContentLength: 100000000,
        maxBodyLength: 1000000000,
        })
    .then(
        res => {
            //  if this is successful cycle through and assign values to states]
            if (!res.data.access_denied) {
               if (method == 'get'){
                  if (url_return){
                     window.location.assign(res.data.url)
                     
                  } else {
                     if (add_influencer_page_alterations === true){
                        this.setState({
                           alteredBio: res.data.influencer_info['description'],
                           alteredDisplayName: res.data.influencer_info['influencer_name'],
                        })
                     }
                     var keys = Object.keys(res.data)
                     for (let i = 0; i < keys.length; i++) {
                        var dict = {}
                        if (inf_scroll){
                           if (keys[i] == 'content_list') {
                              dict[keys[i]] = [...this.state.content_list,  ...res.data.content_list]
                              this.setState(dict)
                           } else if (keys[i] == 'influencer_content') {
                              dict[keys[i]] = [...this.state.influencer_content,  ...res.data.influencer_content]
                              this.setState(dict)
                           } else if (keys[i] == 'influencer_scroll_content') {
                              dict[keys[i]] = [...this.state.influencer_scroll_content,  ...res.data.influencer_scroll_content]
                              this.setState(dict)
                           } else if (keys[i] == 'blog_posts_older') {
                              dict[keys[i]] = [...this.state.blog_posts_older,  ...res.data.blog_posts_older]
                              this.setState(dict)
                           } else if (keys[i] == 'inf_scroll_page_num') {
                              dict[keys[i]] = eval("res.data."+keys[i])
                              this.setState(dict)
                           } else if (keys[i] == 'total_inf_scroll_content') {
                              dict[keys[i]] = eval("res.data."+keys[i])
                              this.setState(dict)
                           } else if (keys[i] == 'max_inf_scroll_content') {
                              dict[keys[i]] = eval("res.data."+keys[i])
                              this.setState(dict)
                           } else if (keys[i] == 'content_comments') {
                              dict[keys[i]] = [...this.state.content_comments,  ...res.data.content_comments]
                              this.setState(dict)
                           } else {
                              dict[keys[i]] = eval("res.data." + keys[i])
                              this.setState(dict)
                           }
                        } else {
                           dict[keys[i]] = eval("res.data." + keys[i])
                           this.setState(dict)
                        }
                     }
                  }
               } else if (method == 'post') {
                  success_func_name(res)
               }
            //  if this fails try and get new assign token using refresh token
            } else {
               if (res.data.url_return){
                  window.location.assign(res.data.url_return)
               } else {
                  window.location.assign('/')
               }
               // throw new Error(res);
            }
        })
    .catch(error => {
        // this prevents infinite loop of home page reset
        const status = error && error.response ? error.response.status : null;
        const is503 = status === 503;

        if (error_func_name) {
            console.log('error_func_name', error_func_name)
            error_func_name(error)
        } else if (!home_page && !is503) {
            window.location.assign('/')
        } else if (!home_page && is503) {
            console.error('Skipping redirect on 503 error for URL:', url);
        }
    }).finally((ret) => {
      logApiRequest(url, performance.now() - startTime)
      return ret;
    })
}
